import React from 'react'
import { useHistory } from 'react-router-dom'
import { submissionService } from '@oneblink/apps-react'
import { FormTypes } from '@oneblink/types'

export default function useCancelForm(
  formDefinition: FormTypes.Form,
): [() => void, boolean] {
  const history = useHistory()
  const [cancelError, setCancelError] = React.useState(false)
  const onCancel = React.useCallback(async () => {
    if (formDefinition) {
      try {
        await submissionService.executeCancelAction(
          { definition: formDefinition, externalId: null },
          {
            onRedirectToAbsoluteUrl: (url) => window.location.assign(url),
            onRedirectToRelativeUrl: history.push,
          },
        )
      } catch (e) {
        setCancelError(true)
      }
    }
  }, [history, formDefinition])

  return [onCancel, cancelError]
}
